import React from "react"
import { cn } from "~/lib/utils"

interface SectionProps {
  children: React.ReactNode
  id?: string
  className?: string
}

export function Section({ children, id, className }: SectionProps) {
  return (
    <section className={cn("mb-16 scroll-mt-20", className)} id={id}>
      {children}
    </section>
  )
}

interface HProps {
  children: React.ReactNode
  id?: string
  className?: string
}

export function H1({ children, id, className }: HProps) {
  return (
    <h1
      className={cn("text-2xl font-normal mb-4 text-primary", className)}
      id={id}
    >
      {children}
    </h1>
  )
}

export function H2({ children, id, className }: HProps) {
  return (
    <h2
      className={cn("text-xl font-normal mb-4 text-primary", className)}
      id={id}
    >
      {children}
    </h2>
  )
}

export function H3({ children, id, className }: HProps) {
  return (
    <h3 className={cn("text-lg font-normal mb-4", className)} id={id}>
      {children}
    </h3>
  )
}

interface PProps {
  children: React.ReactNode
  className?: string
}

export function P({ children, className }: PProps) {
  return <p className={cn("mb-4", className)}>{children}</p>
}

interface ULProps {
  children: React.ReactNode
  className?: string
}

export function UL({ children, className }: ULProps) {
  return <ul className={cn("mb-4 ml-6 list-disc", className)}>{children}</ul>
}

interface LIProps {
  children: React.ReactNode
  className?: string
}

export function LI({ children, className }: LIProps) {
  return <li className={cn("mb-1", className)}>{children}</li>
}
